import components from '../../common/_components';
import ScrollHorizontal from '../../common/_scroll-horizontal';
import './deals-sidebar.scss';

const blockName = 'deals-sidebar';
const listSelector = `.js-${blockName}__list`;
const listItemSelector = `.js-${blockName}__list-item`;

components.add(`js-${blockName}`, (el) => {
    ScrollHorizontal.installTo(el, el.querySelector(listSelector), listItemSelector);
});
